module.exports = __webpack_public_path__ + "static/img/banner1.6e8769b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/banner1.jpg
// module id = hb9j
// module chunks = 1